import { errorValidation } from './utils';

let cabinetPhone = $("#phone");

cabinetPhone.intlTelInput({
    initialCountry: 'md',
    placeholderNumberType: 'aggressive',
    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js",
    separateDialCode: true,
    preferredCountries: ["md"],
    onlyCountries: ["ro", "ua", "md"]
}).inputmask({
    mask: "V9999999",
    definitions: {
        "V": {
            validator: "^[1-9][0-9]*$",
        }
    }
});

// on blur: validate
cabinetPhone.focusout(function () {
    if ($.trim(cabinetPhone.val())) {
        if (cabinetPhone.intlTelInput("isValidNumber")) {
            console.log(window.translations.phoneInvalid);
        } else {
            cabinetPhone.addClass("_error");
        }
    }
});

// on keydown: reset
cabinetPhone.keydown(function () {
    cabinetPhone.removeClass("_error");
});


$.validator.addMethod('validateRegisterPhone', function () {
    if (cabinetPhone.intlTelInput("isValidNumber")) {
        return true;
    } else {
        return false;
    }
}, window.translations.phoneInvalid);


(() => {
    const $form = $("form[name='cabinet']");
    $form.validate({
        ignore: [],
        ...errorValidation,
        errorClass: 'form__error',
        rules: {
            'cabinet[name]': {
                required: true,
            },
            'cabinet[email]': {
                required: true,
                email: true,
            },
            'cabinet[phone]': {
                required: true,
            },
            'cabinet[birthDate]': {
                required: true,
            },
        },
        messages: {
            'cabinet[name]': {
                required: window.translations.required,
            },
            'cabinet[email]': {
                required: window.translations.required,
                email: window.translations.emailInvalid,
            },
            'cabinet[phone]': {
                required: window.translations.required,
            },
            'cabinet[birthDate]': {
                required: window.translations.required,
            },
        },
        submitHandler: (form) => {
            form.submit();
        },
        success: function (label) {
            let name = label.attr('for');
            label.text('');
        },
    });
})();
